import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { filter, map } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  template: `
    <ngx-loading-bar [includeSpinner]="false" height="3px"></ngx-loading-bar>
    <router-outlet></router-outlet>
  `
})
export class AppComponent implements OnInit {
  private readonly defaultTitle = 'Financeiro';

  constructor(
    private router: Router,
    private title: Title,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => {
          const child = this.activatedRoute.firstChild;
          const titleParam = child.snapshot.data['title'];
          if (titleParam) {
            return titleParam;
          }
          return this.defaultTitle;
        })
      )
      .subscribe((ttl: string) => this.title.setTitle(ttl));
  }
}
